var Curriculog = Curriculog || {};

Curriculog.HierarchyToolboxView = (function ($, _, Backbone, HierarchyToolboxView) {

    HierarchyToolboxView = Curriculog.CurriculogView.extend({
        id: 'curriculog-types-column-content',

        initialize: function (options) {
            this.entityTypes = options.entityTypes;
            this.roleTypes = options.roleTypes;
            this.committees = options.committees;

            this.entityTypesToolbox = new Curriculog.EntityTypesToolboxView({
                entityTypes: this.entityTypes,
            });

            this.roleTypesToolbox = new Curriculog.RoleTypesToolboxView({
                roleTypes: this.roleTypes,
            });

            this.committeesToolbox = new Curriculog.CommitteesToolboxView({
                committees: this.committees,
            });

            this.render();
        },

        render: function () {
            this.$el.append(this.entityTypesToolbox.el);
            this.$el.append(this.roleTypesToolbox.el);
            this.$el.append(this.committeesToolbox.el);
        },
    });
    return HierarchyToolboxView;

})($, _, Backbone, Curriculog.HierarchyToolboxView || {});
